import { createAppState } from "@designbycosmic/cosmic-react-state-management";
import layout from "./reducers/layout";
import modal from "./reducers/modal";
import summary from "./reducers/summary";
import translation from "./reducers/translation";

const reducer = {
  layout: layout.reducer,
  modal: modal.reducer,
  summary: summary.reducer,
  translation: translation.reducer,
};

const initialState = {
  layout: layout.initialState,
  modal: modal.initialState,
  summary: summary.initialState,
  translation: translation.initialState,
};

export const { AppStateProvider, AppStateConsumer, useAppState } =
  createAppState(reducer, initialState);

export default {
  AppStateProvider,
  AppStateConsumer,
  useAppState,
};
